import { fillChemicalData } from '@/utils/chemical'
import { getChemicalUniqueKey } from '@/utils/chemical'

const defaultResultsKey = 'results'
const defaultResultKey = 'result'
const defaultChemicalKey = 'chemical'

const constructErrorResultsForEachChemical = ({
  sentStructures,
  errorMessage,
  resultsKey,
  chemicalKey,
  errorCode = 'NETWORK_ERROR',
}) => {
  if (!sentStructures?.length) return []

  const errorResults = sentStructures.map((structure) => ({
    [chemicalKey]: structure,
    // [resultKey]: [],
    error: {
      message: errorMessage,
      code: errorCode,
    },
  }))

  return resultsKey ? { [resultsKey]: errorResults } : errorResults
}

const formatConstructedError = (error) => {
  if (!error) return null
  if (typeof error === 'string') return error
  return error?.message || 'An unknown error occurred while fetching Web T.E.S.T. predictions.'
}

const enrichResponseWithSentStructures = ({
  responseData,
  sentStructures,
  resultsKey,
  chemicalKey,
  getSentChemicalIdentifier,
  getReceivedChemicalIdentifier,
}) => {
  if (!Array.isArray(responseData?.[resultsKey])) return responseData

  const fillChemicalsInResults = (results) =>
    results.map((resultItem) => {
      return {
        ...resultItem,
        [chemicalKey]: fillChemicalData({
          chemical: resultItem?.[chemicalKey],
          sentStructures,
          getReceivedIdentifier: getReceivedChemicalIdentifier,
          getSentIdentifier: getSentChemicalIdentifier,
        }),
        sourceChemical: resultItem?.[chemicalKey],
      }
    })

  return {
    ...responseData,
    [resultsKey]: fillChemicalsInResults(responseData[resultsKey]),
  }
}

const validateSmilesBasic = (smiles) => {
  if (!smiles || typeof smiles !== 'string' || smiles?.trim() === '') return 'Invalid SMILES'
  return null
}

const validateStructures = (chemicals) =>
  chemicals?.map((chemical) => {
    return { chemical, error: validateSmilesBasic(chemical?.smiles) }
  })

const getInvalidChemicalsWithError = (validatedStructures) => validatedStructures?.filter(({ error }) => error)

const getChemicalsToFetch = (validatedStructures) =>
  validatedStructures?.filter(({ error }) => !error).map(({ chemical }) => chemical)

const partitionChemicalsByValidation = (chemicals) => {
  const validatedChemicals = validateStructures(chemicals)
  const validChemicals = getChemicalsToFetch(validatedChemicals)
  const invalidChemicalsWithError = getInvalidChemicalsWithError(validatedChemicals)
  return { validChemicals, invalidChemicalsWithError }
}

const constructValidationErrorResultsForEachChemical = ({ invalidChemicalsWithError, resultsKey, chemicalKey }) => {
  const checkedInvalidChemicalsWithError = invalidChemicalsWithError?.filter(({ error }) => error)
  if (!checkedInvalidChemicalsWithError?.length) return resultsKey ? { [resultsKey]: [] } : []

  const errorResults = checkedInvalidChemicalsWithError.map(({ chemical, error }) => ({
    [chemicalKey]: { ...chemical, id: getChemicalUniqueKey(chemical) },
    error: {
      message: error,
      code: 'VALIDATION_ERROR',
    },
  }))

  return resultsKey ? { [resultsKey]: errorResults } : errorResults
}

export {
  constructErrorResultsForEachChemical,
  enrichResponseWithSentStructures,
  formatConstructedError,
  defaultResultsKey,
  defaultResultKey,
  defaultChemicalKey,
  partitionChemicalsByValidation,
  constructValidationErrorResultsForEachChemical,
  validateSmilesBasic,
}
